<ui-tabs-nav
  *ngIf="tabs.length || addable"
  [ngStyle]="nzTabBarStyle"
  [uiSelectedIndex]="nzSelectedIndex || 0"
  [inkBarAnimated]="inkBarAnimated"
  [addable]="addable"
  [addIcon]="nzAddIcon"
  [hideBar]="nzHideAll"
  [position]="position"
  [extraTemplate]="nzTabBarExtraContent"
  (tabScroll)="nzTabListScroll.emit($event)"
  (selectFocusedIndex)="setSelectedIndex($event)"
  (addClicked)="onAdd()">
  <div
    class="ant-tabs-tab ui-tabs-tab"
    *ngFor="let tab of tabs; let i = index"
    [style.margin-right.px]="position === 'horizontal' ? nzTabBarGutter : null"
    [style.margin-bottom.px]="position === 'vertical' ? nzTabBarGutter : null"
    [class.ant-tabs-tab-active]="nzSelectedIndex === i"
    [class.ui-tabs-tab-active]="nzSelectedIndex === i"
    [class.ant-tabs-tab-disabled]="tab.nzDisabled"
    [class.ui-tabs-tab-disabled]="tab.nzDisabled"
    [attr.tabindex]="getTabIndex(tab, i)"
    [attr.aria-disabled]="tab.nzDisabled"
    [attr.aria-selected]="nzSelectedIndex === i && !nzHideAll"
    [attr.aria-controls]="getTabContentId(i)"
    (click)="clickNavItem(tab, i, $event)"
    (contextmenu)="contextmenuNavItem(tab, $event)"
    data-test-id="tab"
    cdkMonitorElementFocus
    role="tab">
    <div class="ant-tabs-tab-btn ui-tabs-tab-btn" [disabled]="tab.nzDisabled" [tab]="tab" [active]="nzSelectedIndex === i" uiTabNavItem>
      <ng-container *nzStringTemplateOutlet="tab.label; context: { visible: true }">{{ tab.label }}</ng-container>
      <button *ngIf="tab.nzClosable && closable && !tab.nzDisabled" [closeIcon]="tab.nzCloseIcon" (click)="onClose(i, $event)" type="button" ui-tab-close-button></button>
    </div>
    <ui-tab-color-indicator *ngIf="tab.uiTabColor" [color]="tab.uiTabColor"></ui-tab-color-indicator>
  </div>
</ui-tabs-nav>
<div class="ant-tabs-content-holder" *ngIf="!uiHideBody">
  <div
    class="ant-tabs-content"
    [class.ant-tabs-content-top]="nzTabPosition === 'top'"
    [class.ant-tabs-content-bottom]="nzTabPosition === 'bottom'"
    [class.ant-tabs-content-left]="nzTabPosition === 'left'"
    [class.ant-tabs-content-right]="nzTabPosition === 'right'"
    [class.ant-tabs-content-animated]="tabPaneAnimated">
    <div
      *ngFor="let tab of tabs; let i = index"
      [id]="getTabContentId(i)"
      [attr.aria-labelledby]="getTabContentId(i)"
      [active]="nzSelectedIndex === i && !nzHideAll"
      [content]="tab.content"
      [forceRender]="tab.nzForceRender"
      [tabPaneAnimated]="tabPaneAnimated"
      role="tabpanel"
      ui-tab-body></div>
  </div>
</div>
